import { createContext, useContext } from 'react'
import arduinoStore from './arduinoStore'

interface Store {
    arduinoStore: arduinoStore
}

export const store: Store = {
  arduinoStore: new arduinoStore()
}

export const StoreContext = createContext(store)

export function useStore () {
  return useContext(StoreContext)
}
